import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';

type VisibleType = {
  visible: boolean;
};

const GlobalStyle = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;
const OverlayContainer = styled.div<VisibleType>`
  display: ${props => props.visible ? 'block': 'none'};
  position: fixed;
  top: 0;
  left: 0;
  background: rgb(28,60,92);
  background: linear-gradient(180deg, rgba(28,60,92,0.9) 0%, rgba(22,26,37,0.9) 100%);
  background-repeat: no-repeat;
  background-attachment: fixed;
  height: 100vh;
  width: 100vw;
`;
const OverlayContent = styled.div`
  margin: auto;
  max-width: 1240px;
  position: relative;
  height: 100%;
`;

interface IOwnProps {
  visible: boolean;
  children: React.ReactNode;
};

type Props = IOwnProps;

function Overlay(props: Props) {
  return (
    <React.Fragment>
      {props.visible && <GlobalStyle />}
      <OverlayContainer visible={props.visible}>
        <OverlayContent>
          {props.children}
        </OverlayContent>
      </OverlayContainer>
    </React.Fragment>
  );
}

export default Overlay;